import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import style from "./BannerDetailModal.module.css";

import { BrowserDetectContext } from "providers/BrowserEventProvider";




const BannerDetailModal = NiceModal.create(
    (props, ref) => {
        const { isMobile } = useContext(BrowserDetectContext);
        const modal = useRef();
        const { t } = useTranslation();
        const [withHeader, withFooter] = [false,
            false];
        const [width, height] = [isMobile ? "90%" : "80%", isMobile ? "75vh" : "80%"];
        const withCloseButton = true;
        const clickOutsideToClose = true;
        const title = "문의 사항";
        const { image, img } = props;
        const buttonText = "close";

        return (
            <ModalBase borderRadius={"25px"} ref={modal} width={width} height={height} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText}>
                {
                    isMobile
                        ?
                        <img
                            className={style.slideImg}
                            width={"100%"}
                            height={"100%"}
                            src={image && image}
                            alt=""
                        />
                        //     {/* 나중에 쓰게 될 배너 이미지 뷰   */}
                        // {/* {slide.img.startsWith("PHA") ? (
                        //         <QuillViewer value={decode(slide.img)} />
                        //     ) : (
                        //         <QuillViewer value={slide.img} />
                        //     )} */}
                        :
                        <img
                            className={style.slideImg}
                            width={"100%"}
                            height={"100%"}
                            src={image && image}
                            alt=""
                        />
                    // {/* 나중에 쓰게 될 배너 이미지 뷰   */}
                    //     {/* {slide.img.startsWith("PHA") ? (
                    //     <QuillViewer value={decode(slide.img)} />
                    // ) : (
                    //     <QuillViewer value={slide.img} />
                    // )} */}

                }

            </ModalBase>
        );
    }
);


export default BannerDetailModal;